<template>
  <view
    class="ts-collapse"
    wx:class="{{externClass}}"
    wx:ref="collapse"
    wx:style="{{[transitionStyle,expandStyle]}}"
  >
    <view class="slot-container">
      <slot />
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'
  import { debounce, trackEvent } from '@didi/spring-base'

  createComponent({
    props: {
      expand: {
        type: Boolean,
        value: true
      },
      fadeDuration: {
        type: Number,
        value: 0.3
      },
      externClass: {
        type: String,
        value: ''
      },
      refreshTrigger: {
        type: Boolean,
        value: false
      }
    },
    data() {
      return {
        expandStyle: {}
      }
    },
    ready() {
      trackEvent('spring-ui-collapse-init', '手风琴埋点-初始化', {
        init: true
      })
      this.setExpandStyle()
    },
    watch: {
      expand: {
        handler(val) {
          this.setExpandStyle()
        }
      },
      refreshTrigger(val, oldVal) {
        if (val === oldVal) return
        this.setExpandStyle()
      }
    },
    computed: {
      transitionStyle() {
        return {
          // transition: `height ${this.fadeDuration}s, opacity ${this.fadeDuration}s, overflow ${this.fadeDuration}s`
          'transition-duration': `${this.fadeDuration}s`
        }
      }
    },
    methods: {
      setExpandStyle() {
        this.$nextTick(() => {
          const heihgt = this.$refs?.collapse?._selector?.scrollHeight ?? 0
          if (this.expand) {
            this.expandStyle = {
              opacity: 1,
              'grid-template-rows': '1fr',
            }
          } else {
            this.expandStyle = {
              opacity: 0,
              'grid-template-rows': '0fr',
              overfow: 'hidden'
            }
          }
        })
      }
    }
  })
</script>

<style scoped lang="stylus">
.ts-collapse
  display grid 
  transition  grid-template-rows 0.5s 0s, opacity 0.5s 0.1s
  grid-template-columns 100%
  overflow hidden
  .slot-container
    min-height 0
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {}
  }
</script>